// The ritrovo is typed as a time and travels as an instant: the clocks that matter are those of
// the pitch, Italy's, whatever the browser's are.

const PITCH_TIME_ZONE = 'Europe/Rome'

// 'en-GB' with `h23` and not 'it-IT': only the digits are read back, and midnight is `00`, not `24`.
const wallClock = new Intl.DateTimeFormat('en-GB', {
  timeZone: PITCH_TIME_ZONE,
  hourCycle: 'h23',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
})

const timeOfDay = new Intl.DateTimeFormat('en-GB', {
  timeZone: PITCH_TIME_ZONE,
  hourCycle: 'h23',
  hour: '2-digit',
  minute: '2-digit',
})

interface WallClockFields {
  readonly year: number
  readonly month: number
  readonly day: number
}

function fieldsAt(instant: number): WallClockFields & { readonly asUtc: number } {
  const read = new Map(wallClock.formatToParts(instant).map((part) => [part.type, part.value]))
  const field = (type: Intl.DateTimeFormatPartTypes) => Number(read.get(type))
  return {
    year: field('year'),
    month: field('month'),
    day: field('day'),
    asUtc: Date.UTC(
      field('year'),
      field('month') - 1,
      field('day'),
      field('hour'),
      field('minute'),
      field('second'),
    ),
  }
}

/** How far the clocks of Italy stand ahead of UTC at that instant, in milliseconds. */
function offsetAt(instant: number): number {
  return fieldsAt(instant).asUtc - Math.floor(instant / 1000) * 1000
}

/** `time` («09:30») on the day the match is played, in Italy, as an ISO instant. The day is the
 *  one on the clocks of the pitch: a kick-off at 01:30 is already the next day in UTC's eyes. */
export function meetingInstant(kicksOffAt: string, time: string): string {
  const { year, month, day } = fieldsAt(new Date(kicksOffAt).getTime())
  const [hours, minutes] = time.split(':').map(Number)
  const wall = Date.UTC(year, month - 1, day, hours, minutes)
  // Twice: the offset is asked at the guess, and corrected where the guess landed.
  const guess = wall - offsetAt(wall)
  return new Date(wall - offsetAt(guess)).toISOString()
}

/** The time a saved ritrovo reads back as in the field, or the empty string for none. */
export function meetingTimeOf(meetingAt: string | null): string {
  return meetingAt === null ? '' : timeOfDay.format(new Date(meetingAt))
}
